module.exports = __webpack_public_path__ + "img/wallet_02_advanced_3.f5f9233d.png";